import React from "react";
import classNames from "classnames";
import styles from "./CloseButton.module.scss";

interface Props {
    handleClose: () => void;
    className?: string;
}
const CloseButton = ({ handleClose, className }: Props) => {
    return (
        <button
            type="button"
            className={classNames(styles["close-btn"], className)}
            aria-label="Close"
            onClick={handleClose}
        >
            <span>&times;</span>
        </button>
    );
};

export default CloseButton;
